angular.module('dnecom')
    .service('IdleWatcher', ["$interval", function ($interval) {
        this.create = function (scope, objectBeingWatched, callback, idleSeconds) {
            var watcherPromise = null;

            if (_.isUndefined(idleSeconds)) {
                idleSeconds = 10;
            }

            scope.$watch(objectBeingWatched, function () {
                if (watcherPromise) {
                    $interval.cancel(watcherPromise);
                }

                watcherPromise = $interval(callback, idleSeconds * 1000);
            }, true);
        };
    }]);

